function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBinoculars = function SvgBinoculars(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "binoculars_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    d: "M0 0h20v20H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#binoculars_svg__a)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.657 9.039c-.989-1.083-4.064-4.446-4.212-4.594-.866-.867-2.47-.877-3.326 0-.645.66-1.598.673-2.23 0-.839-.894-2.466-.866-3.333 0-.113.113-3.059 3.344-4.11 4.498a4.444 4.444 0 1 0 7.331 2.286 2.09 2.09 0 0 1 2.446 0 4.444 4.444 0 1 0 7.433-2.19ZM4.444 14.444a2.222 2.222 0 1 0 0-4.444 2.222 2.222 0 0 0 0 4.444Zm13.334-2.222a2.222 2.222 0 1 1-4.444 0 2.222 2.222 0 0 1 4.444 0Z",
    style: {
      fillRule: "evenodd"
    }
  })));
};
export default SvgBinoculars;